import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData, getFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";


interface FacilitadorSesionState {
    status: string;
    error: string;
    facilitadorSesion: {
        idGrupoSesion: number | null;
        idSesion: number | null;
        nombreModulo: string | null;
        estadoModulo: boolean | null;
        nombre: string | null;
        temas: string | null;
        valores: string | null;
        linkSesion: string | null;
        idTipoSesion: number | null;
        fecha: string | null;
        urlGrupo: string | null;
        horario: string | null;
        estado: number | null;
        fileData: string | null;
        fileUrl: string | null;
    }
}

const initialState: FacilitadorSesionState = {
    status: "",
    error: "",
    facilitadorSesion: {
        idGrupoSesion: null,
        idSesion: null,
        nombreModulo: null,
        estadoModulo: null,
        nombre: null,
        temas: null,
        valores: null,
        linkSesion: null,
        idTipoSesion: null,
        fecha: null,
        urlGrupo: null,
        horario: null,
        estado: null,
        fileData: null,
        fileUrl: null
    }
}

export const fetchFacilitadorSesion = createAsyncThunk('fetchFacilitadorSesion', async ({ idGrupoSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 121;
    const { result, message, data } = await getData({ idsp, idGrupoSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const downloadGuia = createAsyncThunk('downloadGuia', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const facilitadorSesionNew = selectFacilitadorSesion(state);
    const facilitadorSesionAttributes = { ...facilitadorSesionNew };
    let alert: AlertInterface;
    if (facilitadorSesionAttributes.fileUrl) {
        const fileExtension = facilitadorSesionAttributes.fileUrl.substring(facilitadorSesionAttributes.fileUrl.lastIndexOf('.'));
        const fileName = `guia_${facilitadorSesionAttributes.nombre}${fileExtension}`;
        const response = await getFile({ fileUrl: facilitadorSesionAttributes.fileUrl, fileName: fileName });
        
        if (response && response.blob) {
            saveAs(response.blob, fileName);
            alert = { title: 'CORRECTO..!', message: "GUÍA DESCARGADA CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
        } else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
        }
    } else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
});


export const facilitadorSesionSlice = createSlice({
    name: 'facilitadorSesion',
    initialState,
    reducers: {
        setFacilitadorSesion: (state, action) => {
            state.facilitadorSesion = !action.payload ? initialState.facilitadorSesion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchFacilitadorSesion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitadorSesion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.facilitadorSesion = data ? data[0] : null;

            })
            .addCase(fetchFacilitadorSesion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })

    }
})

export const selectFacilitadorSesion = (state: RootState) => state.facilitadorSesion.facilitadorSesion;

export const { setFacilitadorSesion } = facilitadorSesionSlice.actions;

export default facilitadorSesionSlice.reducer;
